import React, { useState, useEffect } from "react";
import {
  Button,
  Input,
  Form,
  Select,
  message,
  InputNumber,
  Checkbox,
  Modal,
  Row,
  Col,
  DatePicker,
  notification,
  Typography,
  Alert,
  Radio
} from "antd";
import { Table } from "antd";
import { SearchOutlined, EditFilled, SmileOutlined } from "@ant-design/icons";
import "../css/product.css";
import axios from "axios";
import { path, src } from "../network/conn";
import FormItem from "antd/lib/form/FormItem";
import moment from "moment";

const ExpenseEntry = (props) => {
  const userName = sessionStorage.getItem("user");
  const [paymentList, setpaymentList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [inwardDataSource, setInwardDataSource] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [labourList, setLabourList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [inwardProduct, setInwardProduct] = useState([]);
  const [submitType, setsubmitType] = useState("insert");
  const [loading, setLoading] = useState(false);
  const [productType,setproductType]=useState(' ');
  const [disabledButton, setdisabledButton] = useState(false);
  const [userSetting,setUserSetting] = useState({});
  const [form] = Form.useForm();
  const key = "updatable";
  const logUser = window.sessionStorage.getItem("user");
  const { Option } = Select;
  const openMessageLoading = (load) => {
    message.loading({ content: load, key });
  };
  const openMessageSuccess = (loaded) => {
    message.success({ content: loaded, key, duration: 2 });
  };
  const openQuanNotification = () => {
    notification.open({
      message: "Error",
      description: "Amount Exceeds",
      icon: <SmileOutlined style={{ color: "#108ee9", color: "red" }} />,
    });
  };
  
  const openModal = () => {
      setsubmitType("insert");
    setModalVisible(true);
    setdisabledButton(false);
  };
  const closeModal = () => {
    setModalVisible(false);
    form.resetFields();
    setproductType(' ');
    document.getElementById('available').innerHTML = 0;
  };
  
  const fetchExpenseList = () => {
    let BaseURL = path + src + "expense_entry_list.php";
    axios
      .get(BaseURL)
      .then((response) => {
          let sortData = response.data.sort((a,b)=> {return b.id-a.id})
        setInwardDataSource(sortData);
        setLoading(false);
      })
      .catch((error) => console.log(error));
  };
  const fetchLabourList = () => {
    let BaseURL = path + src + "employeelist.php";
    axios
      .get(BaseURL)
      .then((response) => setLabourList(response.data))
      .catch((error) => console.log(error));
  };
  
  
  const handleValidation = (value) => {
    let quantity = form.getFieldValue("amount");
    console.log(quantity);
    let available =document.getElementById("available").innerHTML;
    console.log(available);
    if (Number(quantity) > Number(available)) {
      openQuanNotification();
      form.setFieldsValue({
        amount: "",
      });
    }
  };
  const fetchAvailable = (value) => {
      console.log(value);
      let BaseUrl =
      path +
      src +
      "fetch_payment_report.php";
    axios
      .get(BaseUrl)
      .then((response) => {
        console.log(response);
        response.data.map((list)=>{
            if(list.code==value){
                document.getElementById("available").innerHTML=list.amount;
                form.setFieldsValue({
                    quantity: "",
                  });
            }
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const fetchAvailableEdit = (value,amount) => {
    console.log(value);
    let BaseUrl =
    path +
    src +
    "fetch_payment_report.php";
  axios
    .get(BaseUrl)
    .then((response) => {
      console.log(response);
      response.data.map((list)=>{
          if(list.code==value){
              document.getElementById("available").innerHTML=Number(list.amount)+Number(amount);
              form.setFieldsValue({
                  quantity: "",
                });
          }
      });
    })
    .catch((error) => {
      console.log(error);
    });
};
  const handleEdit = (record) => {
    setdisabledButton(false);
    setsubmitType("update");
    let code = record.code;
    let BaseURL =
      path +
      src +
      "edit_expense_entry.php?code=" +
      code;

    axios
      .get(BaseURL)
      .then((response) => {
        console.log(response);
        fetchAvailableEdit(response.data.payment,response.data.amount);
        console.log(response.data.date);
        setModalVisible(true);
        form.setFieldsValue({
          date: moment(response.data.date),
          code:response.data.code,
          expense:response.data.expense,
          staff:response.data.staff,
          payment:response.data.payment,
          amount : response.data.amount
        });
      })
      .catch((error) => console.log(error));
  };
  const fetchPayment = () => {
    let BaseURL = path + src + "paymentlist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setpaymentList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const fetchExpenseEntryList = () => {
    let BaseURL = path + src + "expenselist.php";
    axios
      .get(BaseURL)
      .then((response) => {
        setExpenseList(response.data);
      })
      .catch((error) => {
        openMessageSuccess(error, 10);
      });
  };
  const profile = window.sessionStorage.getItem("profile");
  const fetch_profile_permission = (profile) =>{
    console.log('profile',profile);
    let BaseURL = path + src + "fetch_profile_permission.php?profile="+profile;
    axios
    .get(BaseURL)
      .then((response) => {
        console.log(response.data);
        let dataObj = {};
        response.data.map((list)=>{
          let permissionObj = {};
          if(list.filename == 'expenseentry'){
          permissionObj['add']      = list.add;
          permissionObj['edit']     = list.edit;
          permissionObj['delete']   = list.delete;
          permissionObj['show']     = list.show;
          permissionObj['print']    = list.print;
          permissionObj['excel']    = list.excel;
          permissionObj['profile']  = list.profile;
          dataObj[list.filename]    =  permissionObj;
          setUserSetting(permissionObj);
          }
        })
       
       console.log('dataObj',dataObj);
      })
      .catch((error) => {
        //openMessageSuccess(error, 10);
        console.log(error);
      });
    }
  const handleSubmit = (data) => {
    setdisabledButton(true);
    setsubmitType("insert");
    openMessageLoading("Loading", 20);
    const submitData = {
      expenseData: data,
      submittype: submitType,
      dateCode: moment(form.getFieldValue("date")).format("YYYY-MM-DD"),
      user: logUser,
    };
    let BaseURL = path + src + "insert_expense_entry.php";
    axios
      .post(BaseURL, submitData)
      .then((response) => {
        setLoading(true);
        closeModal();
        openMessageSuccess(response.data);
        fetchExpenseList();
      })
      .catch();
  };
  useEffect(() => {
    fetchLabourList();
    fetchExpenseList();
    fetchPayment();
    fetchExpenseEntryList();
    fetch_profile_permission(profile);
  }, []);
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
  };
  const expenseTableColumn = [
    {
      key: "1",
      title: "Sno",
      dataIndex: "id",
    },
    {
      key: "2",
      title: "Date",
      dataIndex: "date",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.date.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "3",
      title: "Code",
      dataIndex: "code",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.code.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "4",
      title: "Staff",
      dataIndex: "name",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.name.toLowerCase().includes(value.toLowerCase());
      },
      
    },
    {
      key: "5",
      title: "Expense",
      dataIndex: "expense",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.expense.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "6",
      title: "Payment",
      dataIndex: "paymenttype",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              placeholder="Type To Search"
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
                confirm({ closeDropdown: false });
              }}
              onBlur={() => {
                confirm({ closeDropdown: false });
              }}
            ></Input>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },
      onFilter: (value, record) => {
        return record.paymenttype.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      key: "7",
      title: "Amount",
      dataIndex: "amount",
    },
    {
      key: "8",
      title: "Edit",
      render: (record) => (
        Number(userSetting.edit) == 1 ? <Button type="primary" size="small" onClick={() => handleEdit(record)}>
          <EditFilled></EditFilled>
        </Button> : ''
      ),
    },
  ];
  return (
    <>
     {Number(userSetting.add) == 1 ? <Button className="addButton" type="primary" onClick={openModal}>
        +Create Expense Entry
      </Button> : ''} 
      <Table
        columns={expenseTableColumn}
        dataSource={inwardDataSource}
        loading={loading}
        pagination={{ pageSize: 5 }}
        className="tableData"
      ></Table>
      <Modal
        visible={modalVisible}
        onCancel={() => closeModal()}
        width={1000}
        footer={null}
        maskClosable={false}
        title="Add ExpenseEntry"
      >
        <Form
          layout="vertical"
          form={form}
          name="nest-messages"
          onFinish={handleSubmit}
        >
          <Row gutter={16}>
            <Col span={8} hidden={submitType=="insert"?true:false}>
              <Form.Item label="Code" name="code" rules={[{  }]} >
                <Input style={{ width: "100%" }} disabled={true}></Input>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Date" name="date" rules={[{ required: true }]}>
                <DatePicker
                  style={{ width: "100%" }}
                  value={moment()}
                  format="DD-MM-YYYY"
                ></DatePicker>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Expense"
                name="expense"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select Expense"
                >
                  <Option value="advance">Advance</Option>
                  {expenseList.map((list) => (
                    <Option value={list.code}>{list.expense}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                label="Staff"
                name="staff"
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Select Staff"
                >
                  {labourList.map((list) => (
                    <Option value={list.employeecode}>{list.employeename}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                label="Payment"
                name="payment"
                rules={[{ required: true }]}
              >
                  <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              placeholder="Select payment"
              onChange={fetchAvailable}
            >
                {paymentList.map((list) => (
                <Option value={list.code}>{list.payment}</Option>
              ))}
            </Select>
              </Form.Item>
            </Col>
            <Col span={6}><br/><br/>
              <span>Available  :  <span id="available"></span></span></Col>
          </Row>
            <Row gutter={24}>
            <Col span={5}>
              <label>Amount</label>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={5}>
              <Form.Item rules={[{ required: true }]} name="amount">
                <Input placeholder="Amount" onChange={handleValidation}
                ></Input>
              </Form.Item>
            </Col>
            <Col span={2}>
              <Button
                className="addButton"
                type="primary"
                htmlType="submit"
                disabled={disabledButton}
              >
                Add
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};
export default ExpenseEntry;
